import { MODULE_TYPE_LABELS } from "entities/modules/constants";
import { ModuleIcon, ModuleType } from "entities/modules/types";
import { FC, ReactNode } from "react";
import { SelectOption } from "shared/components/Form/Select";
import { BadgeDiscountIcon } from "shared/theme/icons/BadgeDiscountIcon";
import { CardsIcon } from "shared/theme/icons/CardsIcon";
import { CheckmarkBadgeIcon } from "shared/theme/icons/CheckmarkBadgeIcon";
import { ChipIcon } from "shared/theme/icons/ChipIcon";
import { DiceIcon } from "shared/theme/icons/DiceIcon";
import { FireIcon } from "shared/theme/icons/FireIcon";
import { GiftIcon } from "shared/theme/icons/GiftIcon";
import { HeartIcon } from "shared/theme/icons/HeartIcon";
import { InfoIcon } from "shared/theme/icons/InfoIcon";
import { PlayIcon } from "shared/theme/icons/PlayIcon";
import { PuzzleIcon } from "shared/theme/icons/PuzzleIcon";
import { QuestionMarkIcon } from "shared/theme/icons/QuestionMarkIcon";
import { RecentlyIcon } from "shared/theme/icons/RecentlyIcon";
import { RouletteIcon } from "shared/theme/icons/RouletteIcon";
import { StarBigIcon } from "shared/theme/icons/StarBigIcon";
import { TicketDiscountIcon } from "shared/theme/icons/TicketDiscountIcon";
import { TicketIcon } from "shared/theme/icons/TicketIcon";
import { TimeIcon } from "shared/theme/icons/TimeIcon";
import { TrophyIcon } from "shared/theme/icons/TrophyIcon";
import { IconType } from "shared/theme/icons/types";
import ContentBlocksSection from "./components/ContentBlocksSection";
import GamesLayoutModuleSection from "./components/GamesLayoutModuleSection";
import LayoutModuleSection from "./components/LayoutModuleSection";
import ProductIframeSection from "./components/ProductIframeSection";
import PromotionSection from "./components/PromotionSection";
import TopPrivacyTipsSection from "./components/TopPrivacyTipsSection";

export const moduleConfigurationView: Record<ModuleType, ReactNode | null> = {
  [ModuleType.Games]: <GamesLayoutModuleSection />,
  [ModuleType.Studios]: <LayoutModuleSection />,
  [ModuleType.ProductIframe]: <ProductIframeSection />,
  [ModuleType.MarqueeCards]: null,
  [ModuleType.ContentBlocks]: <ContentBlocksSection />,
  [ModuleType.Promotion]: <PromotionSection />,
  [ModuleType.TopPrivacyTips]: <TopPrivacyTipsSection />,
  [ModuleType.FavouriteGames]: null,
  [ModuleType.RecentlyPlayed]: null,
  [ModuleType.RecentWithdrawals]: null,
  [ModuleType.TopWinners]: null,
};

export const moduleTypeOptions: SelectOption[] = [
  { value: ModuleType.Games, label: MODULE_TYPE_LABELS[ModuleType.Games] },
  { value: ModuleType.Studios, label: MODULE_TYPE_LABELS[ModuleType.Studios] },
  {
    value: ModuleType.MarqueeCards,
    label: MODULE_TYPE_LABELS[ModuleType.MarqueeCards],
  },
  {
    value: ModuleType.ProductIframe,
    label: MODULE_TYPE_LABELS[ModuleType.ProductIframe],
  },
  {
    value: ModuleType.ContentBlocks,
    label: MODULE_TYPE_LABELS[ModuleType.ContentBlocks],
  },
  {
    value: ModuleType.Promotion,
    label: MODULE_TYPE_LABELS[ModuleType.Promotion],
  },
  {
    value: ModuleType.RecentlyPlayed,
    label: MODULE_TYPE_LABELS[ModuleType.RecentlyPlayed],
  },
  {
    value: ModuleType.FavouriteGames,
    label: MODULE_TYPE_LABELS[ModuleType.FavouriteGames],
  },
  {
    value: ModuleType.RecentWithdrawals,
    label: MODULE_TYPE_LABELS[ModuleType.RecentWithdrawals],
  },
  {
    value: ModuleType.TopWinners,
    label: MODULE_TYPE_LABELS[ModuleType.TopWinners],
  },
  {
    value: ModuleType.TopPrivacyTips,
    label: MODULE_TYPE_LABELS[ModuleType.TopPrivacyTips],
  },
];

export const moduleIcons: { name: ModuleIcon; Component: FC<IconType> }[] = [
  { name: ModuleIcon.CheckmarkBadge, Component: CheckmarkBadgeIcon },
  { name: ModuleIcon.Chip, Component: ChipIcon },
  { name: ModuleIcon.QuestionMark, Component: QuestionMarkIcon },
  { name: ModuleIcon.Cards, Component: CardsIcon },
  { name: ModuleIcon.Dice, Component: DiceIcon },
  { name: ModuleIcon.Play, Component: PlayIcon },
  { name: ModuleIcon.Roulette, Component: RouletteIcon },
  { name: ModuleIcon.Heart, Component: HeartIcon },
  { name: ModuleIcon.Star, Component: StarBigIcon },
  { name: ModuleIcon.Fire, Component: FireIcon },
  { name: ModuleIcon.Recently, Component: RecentlyIcon },
  { name: ModuleIcon.Gift, Component: GiftIcon },
  { name: ModuleIcon.Ticket, Component: TicketIcon },
  { name: ModuleIcon.TicketDiscount, Component: TicketDiscountIcon },
  { name: ModuleIcon.Puzzle, Component: PuzzleIcon },
  { name: ModuleIcon.Time, Component: TimeIcon },
  { name: ModuleIcon.Info, Component: InfoIcon },
  { name: ModuleIcon.BadgeDiscount, Component: BadgeDiscountIcon },
  { name: ModuleIcon.Trophy, Component: TrophyIcon },
];
